import IsaasIntegration from "./IsaasIntegration.js";

/**
 * `TwinfieldIsaasIntegration` is a concrete implementation of `AbstractIntegration`
 * for integration with Twinfield using iSaaS.
 */
export default class TwinfieldIsaasIntegration extends IsaasIntegration {
	getName() {
		return "Twinfield";
	}

	routeName() {
		return "isaas-twinfield";
	}

	static getType() {
		return "TwinfieldIsaasIntegration";
	}
}
